export default __webpack_public_path__ + "static/media/relationshipblog.d0f61d8d.jpeg";